import { type SVGProps } from "react"

import { cn } from "@/lib/utils"

export const RhythmsLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 24}
    height={props.height ?? 24}
    fill="none"
    {...props}
    viewBox="0 0 204 204" // default viewBox
    className={cn("text-brand shrink-0 p-px", props.className)}
  >
    <path
      d="M203.826 107.939C203.942 105.954 204 103.953 204 101.939C204 99.9249 203.942 97.9243 203.826 95.939H171.336C166.211 95.939 161.332 98.1236 157.919 101.939C161.332 105.755 166.211 107.939 171.336 107.939H203.826Z"
      fill="currentColor"
    />
    <path
      d="M202.417 119.939H171.336C162.685 119.939 154.455 116.205 148.758 109.694L141.973 101.939L148.758 94.1839C154.455 87.6735 162.685 83.9391 171.336 83.9391H202.417C201.689 79.8495 200.717 75.8444 199.517 71.9391H171.336C159.224 71.9391 147.703 77.1672 139.727 86.2819L134 92.8275L133.945 92.7649L125.973 101.876L126.027 101.939L125.973 102.002L133.945 111.113L134 111.051L139.727 117.596C147.703 126.711 159.224 131.939 171.336 131.939H199.517C200.717 128.034 201.689 124.029 202.417 119.939Z"
      fill="currentColor"
    />
    <path
      d="M194.979 143.939H171.226C155.655 143.939 140.841 137.217 130.587 125.498L117.945 111.051L109.973 120.162L121.556 133.4C134.089 147.723 152.194 155.939 171.226 155.939H188.549C190.948 152.103 193.099 148.095 194.979 143.939Z"
      fill="currentColor"
    />
    <path
      d="M179.772 167.939H171.117C148.624 167.939 127.227 158.23 112.416 141.302L109.973 138.51L110.027 138.448L102.055 129.336L102 129.399L101.945 129.336L93.9726 138.448L94.0274 138.51L91.5845 141.302C76.7732 158.23 55.3758 167.939 32.8835 167.939H24.2284C27.8824 172.24 31.8868 176.235 36.1976 179.878C60.9288 178.968 84.2545 167.903 100.615 149.204L102 147.622L103.385 149.204C119.745 167.903 143.071 178.968 167.802 179.878C172.113 176.235 176.118 172.24 179.772 167.939Z"
      fill="currentColor"
    />
    <path
      d="M15.4506 155.939H32.7739C51.8058 155.939 69.9114 147.723 82.444 133.4L130.587 78.3798C140.841 66.661 155.655 59.9391 171.226 59.9391H194.979C193.099 55.7831 190.948 51.7756 188.549 47.9391H171.226C152.194 47.9391 134.089 56.1548 121.556 70.4777L73.413 125.498C63.1591 137.217 48.3455 143.939 32.7739 143.939H9.02087C10.9012 148.095 13.0519 152.103 15.4506 155.939Z"
      fill="currentColor"
    />
    <path
      d="M4.48318 131.939H32.6643C43.6392 131.939 54.1299 127.646 61.9364 120.058L54.0191 111.01C48.4001 116.705 40.7146 119.939 32.6643 119.939H1.5832C2.31134 124.029 3.28318 128.034 4.48318 131.939Z"
      fill="currentColor"
    />
    <path
      d="M0 101.939C0 103.953 0.0583804 105.954 0.173541 107.939H32.6643C37.7894 107.939 42.6682 105.755 46.0808 101.939C45.6923 101.505 45.2849 101.092 44.8602 100.7C41.5543 97.6545 37.206 95.939 32.6643 95.939H0.173541C0.0583804 97.9243 0 99.9249 0 101.939Z"
      fill="currentColor"
    />
    <path
      d="M1.5832 83.9391H32.6643C41.3152 83.9391 49.545 87.6735 55.2416 94.1839L70.0548 111.113L78.0274 102.002L64.2726 86.2819C56.2973 77.1672 44.7756 71.9391 32.6643 71.9391H4.48318C3.28318 75.8444 2.31134 79.8495 1.5832 83.9391Z"
      fill="currentColor"
    />
    <path
      d="M9.02087 59.9391H32.7739C48.3455 59.9391 63.1591 66.661 73.413 78.3798L86.0548 92.8275L94.0274 83.716L82.444 70.4777C69.9113 56.1548 51.8058 47.9391 32.7739 47.9391H15.4506C13.0519 51.7756 10.9012 55.7831 9.02087 59.9391Z"
      fill="currentColor"
    />
    <path
      d="M24.2284 35.9391H32.8835C55.3757 35.9391 76.7732 45.6485 91.5844 62.5757L94.0274 65.3676L93.9726 65.4302L101.945 74.5418L102 74.4792L102.055 74.5418L110.027 65.4302L109.973 65.3676L112.416 62.5757C127.227 45.6485 148.624 35.9391 171.117 35.9391H179.772C176.118 31.6376 172.113 27.6432 167.802 24C143.071 24.9101 119.745 35.9755 103.385 54.6736L102 56.2561L100.615 54.6736C84.2545 35.9755 60.9288 24.9101 36.1976 24C31.8868 27.6432 27.8823 31.6376 24.2284 35.9391Z"
      fill="currentColor"
    />
  </svg>
)
